/**
 *
 * @module ensureArray
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamEnsureArray = factory();
    }

}(this, function() {

    'use strict';

    var UNDEF = 'undefined';

    return function(thing) {

        if (Array.isArray(thing)) {
            return thing;
        } else if (typeof thing === UNDEF) {
            return [];
        } else {
            return [thing];
        }

    };

}));
